import titleLink from '@components/ui-components/title-link/component.js'

export default {
  components: {
    'title-link-cmp': titleLink,
  },
  data() {
    return {}
  },
  methods: {},
}



// WEBPACK FOOTER //
// ./src/templates/components/ui-components/builder/widget/services-highlight/component.js